<template>
  <div class="subpart_div">
    <h2 class="white_title">III. Le parcours aval</h2>
    <h3 class="white_title">Score d'écoute</h3>
    <subpartAR :part_list="['A11', 'A12']" subpart="partAR3" @nextsubpart="nextsubpart"/>
  </div>
</template>

<script>

import subpartAR from "@/components/subpartAR";

export default {
  name: "subpartAR1",
  components: {
    subpartAR
  },
  methods: {
    nextsubpart() {
      console.log('sending nextsubpart from subpartAR');
      this.$emit('nextsubpart');
    },
  },
  emits: ['nextsubpart'],
}
</script>


<style>

</style>